export const PREFIX_CODE = "perfix_code";
export const PREFIX_CODE_LIST_SUCCESSFUL = "perfix_code_list_successfull";

export const INPUT_CHANGEVALUE = "PreFix_Code_input_ChangeValue";
export const SELECT_CHANGEVALUE = "PreFix_Code_Select_ChangeValue";

export const PREFIX_CODE_ADD = "perfix_code_add";
export const PREFIX_CODE_ADD_SUCCESSFUL = "prefix_Code_add_successfull";

export const PREFIX_CODE_ROW_DATA = "prefix_code_Row_data";
export const PREFIX_CODE_ROW_DATA_SUCCESSFUL =
  "prefix_code_row_data_successfull";

export const PREFIX_CODE_DELETE = "Prefix_code_deleted";

export const PREFIX_CODE_SETROWDATA = "PreFix_Code_set_rowdata";
export const MODEL_OPEN = "perfix_code_model_open";
export const MODEL_CLOSE = "perfix_code_model_close";

export const SET_PARAMS = "PreFix_Code_set_params";

export const API_ERROR = "api_failed";
